<div class="esim-catalog-container">
  <div class="header">
    <h1>Catálogo eSIM</h1>
    <p>Descarga el listado completo de paquetes eSIM con precios de coste y venta.</p>
  </div>

  <div class="content">
    <button
      mat-raised-button
      color="primary"
      class="download-button"
      [disabled]="isLoading"
      (click)="downloadCatalog()"
    >
      <span class="button-content">
        <mat-spinner
          *ngIf="isLoading"
          diameter="16"
          strokeWidth="3"
          mode="indeterminate"
          color="accent"
          class="spinner-inline"
        />
        <mat-icon *ngIf="!isLoading">download</mat-icon>
        <span>{{ isLoading ? 'Descargando...' : 'Descargar catálogo (.xlsx)' }}</span>
      </span>
    </button>
  </div>
</div>
